import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { ExposureByGroupConfigEditor } from './ExposureByGroupConfigEditor';
import { PointerConfigEditor } from './PointerConfigEditor';
import { StandardConfigEditor } from './StandardConfigEditor';
import { WeightedAverageConfigEditor } from './WeightedAverageConfigEditor';

export const renderConfigSwitch = (
  config: CreditAgreement.Config.ConcentrationLimit.Calculation.SourceConfig,
  availableFields: CreditAgreement.Config.ConcentrationLimit.Calculation.AvailableField[],
  onChange: (
    newValue: CreditAgreement.Config.ConcentrationLimit.Calculation.SourceConfig,
  ) => void,
) => {
  const type = config.type;
  switch (type) {
    case 'standard':
      return (
        <StandardConfigEditor
          availableFields={availableFields}
          value={config}
          onChange={(newValue) => onChange(newValue)}
        />
      );
    case 'weightedAverage':
      return (
        <WeightedAverageConfigEditor
          availableFields={availableFields}
          value={config}
          onChange={(newValue) => onChange(newValue)}
        />
      );
    case 'exposureByGroup':
      return (
        <ExposureByGroupConfigEditor
          availableFields={availableFields}
          value={config}
          onChange={(newValue) => onChange(newValue)}
        />
      );
    case 'pointer':
      return (
        <PointerConfigEditor
          availableFields={availableFields}
          value={config}
          onChange={(newValue) => onChange(newValue)}
        />
      );
    default:
      // cant assert here, because JSON editor allows it.
      return null;
  }
};
